/* axtlan-currency.js - currency chosen on its own, separate from the language (owner 2026-10-07: "cant currency be
   toggleable sepparatedly? maybe with a small checkbox that sets the language one if wanted" / "you can speak french
   doesnt mean you pay in euros, we should support all currencies shopify support").
   Shopify ties the currency to the buyer's country, so picking a currency submits a country that pays in it: the
   visitor's own country when it already does, otherwise the main country for that currency. The small checkbox
   "Currency follows language" (off by default, remembered in this browser) also switches the currency when a language
   is picked. Data: #ax-currency-data, rendered by sections/axtlan-skin.liquid from localization.available_countries. */
(function () {
  var el = document.getElementById('ax-currency-data');
  if (!el) return;
  var D; try { D = JSON.parse(el.textContent); } catch (e) { return; }
  if (!D || typeof D !== 'object' || Array.isArray(D)) return;
  /* translated texts arrive HTML-escaped from the | t filter (e.g. &amp;): decode once */
  ['label', 'follow', 'langCaption', 'marketCaption', 'note', 'usdNote', 'usdLink', 'usdUrl', 'close'].forEach(function (k) { var t = document.createElement('textarea'); t.innerHTML = D[k] || ''; D[k] = t.value; });
  var KEY = 'axtlan-currency-follows-language';
  /* USD notice text: the sentence, then the link to Shopify's list of supported currencies (new tab) */
  function usdText(p) {
    p.textContent = D.usdNote + ' ';
    if (!D.usdUrl || !/^https:\/\/help\.shopify\.com\//.test(D.usdUrl)) return;
    var a = document.createElement('a'); a.href = D.usdUrl; a.target = '_blank'; a.rel = 'noopener'; a.textContent = (D.usdLink || D.usdUrl) + ' \u2197';
    p.appendChild(a);
  }
  var MAIN = { USD: 'US', EUR: 'DE', GBP: 'GB', AUD: 'AU', NZD: 'NZ', CHF: 'CH', DKK: 'DK', ILS: 'IL', XOF: 'SN', XAF: 'CM', MXN: 'MX' };
  var LANG = { en: 'US', es: 'MX', de: 'DE', fr: 'FR', pt: 'BR', ja: 'JP', ko: 'KR', zh: 'TW', tr: 'TR', id: 'ID', vi: 'VN',
    hu: 'HU', el: 'GR', hi: 'IN', th: 'TH', ta: 'IN', ar: 'SA', ur: 'PK' };
  if (!Array.isArray(D.countries) || !D.countries.every(function (c) {
    return c && typeof c.c === 'string' && /^[A-Z]{2}$/.test(c.c) &&
      typeof c.k === 'string' && /^[A-Z]{3}$/.test(c.k);
  })) return;
  if (new Set(D.countries.map(function (c) { return c.c; })).size !== D.countries.length) return;
  var byCur = {}, has = {};
  D.countries.forEach(function (c) { (byCur[c.k] = byCur[c.k] || []).push(c.c); has[c.c] = c.k; });
  var codes = Object.keys(byCur).sort(function (a, b) { return a === 'MXN' ? -1 : b === 'MXN' ? 1 : a < b ? -1 : 1; });
  var sym = {}; D.countries.forEach(function (c) { if (!sym[c.k]) sym[c.k] = c.s; });
  function countryFor(cur) {
    if (has[D.country] === cur) return D.country;
    if (MAIN[cur] && has[MAIN[cur]] === cur) return MAIN[cur];
    return byCur[cur][0];
  }
  function follows() { try { return localStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
  function setCountry(code) {
    var f = document.createElement('form'); f.method = 'post'; f.action = '/localization'; f.style.display = 'none';
    [['form_type', 'localization'], ['utf8', '✓'], ['_method', 'put'], ['country_code', code],
     ['return_to', location.pathname + location.search]].forEach(function (p) {
      var i = document.createElement('input'); i.type = 'hidden'; i.name = p[0]; i.value = p[1]; f.appendChild(i);
    });
    document.body.appendChild(f); f.submit();
  }
  function build(id) {
    var w = document.createElement('div'); w.className = 'ax-cur';
    var sel = '<select id="' + id + '" aria-label="' + D.label + '">' + codes.map(function (k) {
      return '<option value="' + k + '"' + (k === D.current ? ' selected' : '') + ' title="' + k + ' ' + (sym[k] || '') + '">' + k + '</option>';
    }).join('') + '</select>';
    w.innerHTML = '<label class="ax-cur__pick"><span class="ax-cur__label">' + D.label + '</span>' + sel + '</label>' +
      '<label class="ax-cur__follow"><input type="checkbox"' + (follows() ? ' checked' : '') + '><span>' + D.follow + '</span></label>' +
      '<p class="ax-cur__note">' + D.note + '</p>' + (D.usd ? '<p class="ax-cur__usd"></p>' : '');
    if (D.usd) usdText(w.querySelector('.ax-cur__usd'));
    w.querySelector('select').addEventListener('change', function (e) { setCountry(countryFor(e.target.value)); });
    w.querySelector('input').addEventListener('change', function (e) {
      try { localStorage.setItem(KEY, e.target.checked ? '1' : '0'); } catch (x) {}
      document.querySelectorAll('.ax-cur__follow input').forEach(function (i) { i.checked = e.target.checked; });
    });
    return w;
  }
  /* Two clearly named groups (owner 2026-10-07: "make sure it shows clearly which setting is language of the shop and the
     other that sets country and currency for the checkouts and payments"): "Shop language" = Rise's language picker;
     "Checkout: country & currency" = Rise's country picker + the currency select + the follows-language box. */
  function caption(text) { var c = document.createElement('span'); c.className = 'ax-loc__caption'; c.textContent = text; return c; }
  [['HeaderLanguageForm', 'HeaderCountryForm', 'AxCurrency'], ['HeaderLanguageMobileForm', 'HeaderCountryMobileForm', 'AxCurrencyMobile'],
   ['FooterLanguageForm', 'FooterCountryForm', 'AxCurrencyFooter']].forEach(function (p) {
    var lf = document.getElementById(p[0]), cf = document.getElementById(p[1]);
    if (!cf) return;
    var cHost = cf.closest('localization-form') || cf, lHost = lf ? (lf.closest('localization-form') || lf) : null;
    var parent = cHost.parentNode, first = lHost && lHost.parentNode === parent &&
      (lHost.compareDocumentPosition(cHost) & Node.DOCUMENT_POSITION_FOLLOWING) ? lHost : cHost;
    var anchor = document.createComment('ax-loc'); parent.insertBefore(anchor, first);
    if (lHost) {
      var gl = document.createElement('div'); gl.className = 'ax-loc ax-loc--lang';
      gl.appendChild(caption(D.langCaption)); gl.appendChild(lHost); parent.insertBefore(gl, anchor);
    }
    var gm = document.createElement('div'); gm.className = 'ax-loc ax-loc--market';
    gm.appendChild(caption(D.marketCaption)); gm.appendChild(cHost);
    /* the currency choice lives at the top of the country panel, so the header itself stays two clean rows */
    var panel = cHost.querySelector('.disclosure__list-wrapper');
    if (panel) panel.insertBefore(build(p[2]), panel.firstChild); else gm.appendChild(build(p[2]));
    parent.insertBefore(gm, anchor); parent.removeChild(anchor);
  });
  /* Country search: Rise's box matches anywhere in the name; here a typed prefix ("MEX") puts countries whose name, any
     word of the name, ISO code or currency starts with it first, and Enter picks the first one. */
  function norm(t) { return (t || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim(); }
  document.querySelectorAll('input[name="country_filter"]').forEach(function (inp) {
    var list = inp.closest('localization-form') && inp.closest('localization-form').querySelector('.country-selector__list ul, ul.country-selector__list, .country-selector__list');
    inp.addEventListener('keyup', function () {
      var q = norm(inp.value), lf = inp.closest('localization-form'); if (!lf) return;
      var items = Array.prototype.slice.call(lf.querySelectorAll('a[data-value]'));
      items.forEach(function (a) {
        var name = norm((a.querySelector('.country') || a).textContent), code = norm(a.getAttribute('data-value')),
            cur = norm(has[a.getAttribute('data-value')] || ''), words = name.split(/[\s\-()]+/);
        var rank = !q ? 0 : name.indexOf(q) === 0 ? 1 : words.some(function (w) { return w.indexOf(q) === 0; }) ? 2 :
          code === q || cur.indexOf(q) === 0 ? 3 : name.indexOf(q) > -1 ? 4 : 9;
        a.parentElement.classList.toggle('hidden', rank === 9);
        a.parentElement.style.order = rank;
      });
    });
    inp.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var lf = inp.closest('localization-form'); if (!lf) return;
      var best = Array.prototype.slice.call(lf.querySelectorAll('a[data-value]')).filter(function (a) { return !a.parentElement.classList.contains('hidden') && !a.closest('.popular-countries'); })
        .sort(function (x, y) { return (+x.parentElement.style.order || 0) - (+y.parentElement.style.order || 0); })[0];
      if (best) best.click();
    });
  });
  /* "Currency follows language": the language links submit their form with form.submit(), so the country is added on
     the click, before Rise's own handler submits. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('form[id*="Language"] a[data-value]');
    if (!a || !follows()) return;
    var lang = (a.getAttribute('data-value') || '').slice(0, 2);
    var c = LANG[lang];
    if (!c && lang !== 'fa' && lang !== 'ru') return;
    if (!has[c]) {
      if (!byCur.USD || !byCur.USD.length) return;
      c = countryFor('USD');
    }
    var f = a.closest('form'), i = f.querySelector('input[name="country_code"]');
    if (!i) { i = document.createElement('input'); i.type = 'hidden'; i.name = 'country_code'; f.appendChild(i); }
    i.value = c;
  }, true);
  /* USD notice (overlay step U1, owner 2026-10-08): the chosen country pays in USD because its own currency is not available at checkout here; the
     text names Shopify as the one that sets the currencies a shop can accept and links Shopify's list. One line under the top bars; the close button
     hides it for this browser tab (sessionStorage, per country). */
  if (D.usd && D.usdNote) {
    var SK = 'axtlan-usd-notice-' + D.country, seen = false;
    try { seen = sessionStorage.getItem(SK) === '1'; } catch (e) {}
    if (!seen) {
      var bar = document.createElement('div'); bar.className = 'ax-usd'; bar.setAttribute('role', 'status');
      bar.innerHTML = '<p class="ax-usd__text"></p><button type="button" class="ax-usd__close"><span aria-hidden="true">\u00d7</span></button>';
      usdText(bar.querySelector('p'));
      var x = bar.querySelector('button'); x.setAttribute('aria-label', D.close || 'Close');
      x.addEventListener('click', function () { bar.remove(); try { sessionStorage.setItem(SK, '1'); } catch (e) {} });
      var host = document.getElementById('shopify-section-axtlan_deals') || document.getElementById('shopify-section-axtlan_holiday');
      if (host) host.after(bar); else document.body.prepend(bar);
    }
  }
})();
